import createAsyncAction from "utils/createAsyncAction";

export const GET_SPECIAL_FEATURES_REQUESTED = "GET_SPECIAL_FEATURES_REQUESTED";
export const GET_SPECIAL_FEATURES_SUCCEEDED = "GET_SPECIAL_FEATURES_SUCCEEDED";
export const GET_SPECIAL_FEATURES_FAILED = "GET_SPECIAL_FEATURES_FAILED";

export const getSpecialFeaturesAsync = createAsyncAction(
  "specialFeatures",
  "list",
  "GET_SPECIAL_FEATURES"
);
